import { Loading } from "../../utils/helpers/constants";
import * as ManagerConstants from "../constants/manager.constant";

const initialState = {
  paycenters: [],
  loadingPaycenters: "",
  loadingRoutingConfigs: "",
  loadingMobile: "",
  routeConfigs: [],
  domainMobileBrand: {},
  apiTypes: [],
  loadingApiTypes: "",
  apiIntegrations: [],
  loadingIntegrations: "",
  hideView: [],
  loadingHideView: "",
};

const managerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ManagerConstants.ROUTE_PAYCENTER_REQUEST:
      return { ...state, loadingPaycenters: Loading.FETCHING };

    case ManagerConstants.ROUTE_PAYCENTER_SUCCESS:
      return {
        ...state,
        loadingPaycenters: Loading.SUCCESS,
        paycenters: action.payload,
      };

    case ManagerConstants.ROUTE_PAYCENTER_FAILURE:
      return {
        ...state,
        loadingPaycenters: Loading.ERROR,
      };

    case ManagerConstants.ROUTING_CONFIG_REQUEST:
      return { ...state, loadingRoutingConfigs: Loading.FETCHING };

    case ManagerConstants.ROUTING_CONFIG_SUCCESS:
      return {
        ...state,
        loadingRoutingConfigs: Loading.SUCCESS,
        routeConfigs: action.payload,
      };

    case ManagerConstants.ROUTING_CONFIG_FAILURE:
      return {
        ...state,
        loadingRoutingConfigs: Loading.ERROR,
      };

    case ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_REQUEST:
      return { ...state, loadingMobile: Loading.FETCHING };

    case ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_SUCCESS:
      return {
        ...state,
        domainBrand: action.payload,
        loadingMobile: Loading.SUCCESS,
      };

    case ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_FAILURE:
      return { ...state, loadingMobile: Loading.ERROR };

    case ManagerConstants.LIST_API_TYPES_REQUEST:
      return { ...state, loadingApiTypes: Loading.FETCHING };

    case ManagerConstants.LIST_API_TYPES_SUCCESS:
      return {
        ...state,
        apiTypes: action.payload,
        loadingApiTypes: Loading.SUCCESS,
      };

    case ManagerConstants.LIST_API_TYPES_FAILURE:
      return { ...state, loadingApiTypes: Loading.ERROR };

    case ManagerConstants.LIST_API_INTEGRATIONS_REQUEST:
      return { ...state, loadingIntegrations: Loading.FETCHING };

    case ManagerConstants.LIST_API_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        apiIntegrations: action.payload,
        loadingIntegrations: Loading.SUCCESS,
      };

    case ManagerConstants.LIST_API_INTEGRATIONS_FAILURE:
      return { ...state, loadingIntegrations: Loading.ERROR };

    case ManagerConstants.LIST_HIDE_VIEW_REQUEST:
      return { ...state, loadingHideView: Loading.FETCHING };

    case ManagerConstants.LIST_HIDE_VIEW_SUCCESS:
      return {
        ...state,
        hideView: action.payload,
        loadingHideView: Loading.SUCCESS,
      };

    case ManagerConstants.LIST_HIDE_VIEW_FAILURE:
      return { ...state, loadingHideView: Loading.ERROR };

    default:
      return state;
  }
};

export default managerReducer;
